import { render, staticRenderFns } from "./FilteredPageLinks.vue?vue&type=template&id=21f212dc&scoped=true"
import script from "./FilteredPageLinks.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilteredPageLinks.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FilteredPageLinks.vue?vue&type=style&index=0&id=21f212dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f212dc",
  null
  
)

export default component.exports